<template>
<div class="entry-instructions">
    <p class="text-muted">Your entries are automatically saved as you type.
        You don't need to click anything when you are done.</p>
</div>
</template>

<script>
export default {
    name: "entry-instructions",

    props: [],

    mixins: [],

    data: function () {
        return {}
    },

    asyncComputed: {},

    computed: {},

    methods: {}

}
</script>

<style scoped>

</style>
